// src/components/MaintenanceBanner.js
//
// Lightweight, site-wide notice for a temporary service incident.
// Deliberately generic — no technical or vendor details.
//
// To turn OFF once the incident is resolved: set SHOW_MAINTENANCE_BANNER = false
// and redeploy hosting (npm run build && firebase deploy --only hosting).

import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const SHOW_MAINTENANCE_BANNER = false;
const MAINTENANCE_MESSAGE =
  'Կայքում ժամանակավոր խնդիր կա, և մենք աշխատում ենք շտկել այն։ Շնորհակալություն համբերության համար։';

const MaintenanceBanner = () => {
  if (!SHOW_MAINTENANCE_BANNER) return null;

  return (
    <Box
      role="status"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2100,
        width: '100%',
        backgroundColor: '#fff8e1',
        color: '#7a5b00',
        borderBottom: '1px solid #f0d486',
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        textAlign: 'center',
      }}
    >
      <InfoOutlinedIcon fontSize="small" />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {MAINTENANCE_MESSAGE}
      </Typography>
    </Box>
  );
};

export default MaintenanceBanner;
